import { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Link, useNavigate, useParams } from "react-router-dom";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { handleApiSuccess } from "../../../libs/utils";
import {
  getActivityById,
  getCategoryTitle,
  updateActivity,
  createActivity,
} from "../../../services/timesPoint/timesPointActivity";
import moment from "moment";
import {
  Form,
  Input,
  Select,
  Tooltip,
  Button,
  Row,
  Col,
  Radio,
  InputNumber,
  DatePicker,
  Modal,
  Divider,
  Switch,
  Collapse,
} from "antd";
import request from "superagent";

const { Panel } = Collapse;
const { Option } = Select;

function CreateActivity(props) {
  const navigate = useNavigate();

  const [state, setState] = useState({
    visible: false,
    submitting: false,
    titles: [],
    reloadPage: false,
    platforms: ["web", "msite", "android", "ios"],
  });

  const [activityData, setActivityData] = useState(null);

  const formRef = useRef();
  const { spacode } = useParams();

  useEffect(() => {
    if (spacode !== "0") {
      getActivityById(spacode)
        .then((response) => {
          console.log("response", response);
          const data = response.data?.data;
          if (data) {
            let initialValues = {};
            // Top-level fields
            initialValues.activityName = data.desc;
            initialValues.maxcap = data.maxcap;
            initialValues.climit = data.climit;
            initialValues.capperiod = data.capperiod;
            initialValues.pexpiry = data.pexpiry;
            initialValues.maturityDays = data.maturity_days;
            initialValues.internal = data.internal;
            initialValues.flexiActivity = data.flexiActivity;
            initialValues.atype = data.atype;
            initialValues.channel = data.pcode;
            initialValues.category = data.scode;
            initialValues.clickEvent = data.clickEvent;
            initialValues.bonusActivity = data.bonusActivity;
            initialValues.clientSide = data.isClientSide;
            initialValues.globalValidatorSkip = data.globalValidatorSkip;
            initialValues.timeBound = data.timebound;
            initialValues.startDate = data.startDate;
            initialValues.endDate = data.endDate;
            initialValues.disp = data.disp;
            initialValues.isnew = data.isnew;
            initialValues.en = data.en;
            initialValues.created_by = data.created_by;
            initialValues.last_modified_by = data.last_modified_by;
            // Platform-specific fields
            (data.pfmDetails || []).forEach(pfm => {
              const pfmKey = pfm.pfm;
              initialValues[`${pfmKey}_pfm`] = pfm.pfm;
              initialValues[`${pfmKey}_dlink`] = pfm.dlink;
              initialValues[`${pfmKey}_pts`] = pfm.point;
              initialValues[`${pfmKey}_active`] = pfm.active;
              initialValues[`${pfmKey}_starActivity`] = pfm.starActivity;
              initialValues[`${pfmKey}_orderSequence`] = pfm.orderSequence;
              initialValues[`${pfmKey}_subTitle`] = pfm.subTitle;
              initialValues[`${pfmKey}_actionText`] = pfm.actionText;
              initialValues[`${pfmKey}_image`] = pfm.image;
              initialValues[`${pfmKey}_imageUrl`] = pfm.imageUrl;
            });
            formRef?.current?.setFieldsValue(initialValues);
            setActivityData(data);
          }
        })
        .catch((error) => {});
    }
  }, [spacode]);

  const submitProduct = (values) => {
    // Gather all platform-specific fields into a platforms array
    const platforms = [];
    state.platforms.forEach(platform => {
      const pfmObj = { pfm: platform };
      pfmObj.point = values[platform + "_pts"];
      pfmObj.active = values[platform + "_active"];
      pfmObj.orderSequence = values[platform + "_orderSequence"];
      pfmObj.subTitle = values[platform + "_subTitle"];
      pfmObj.actionText = values[platform + "_actionText"];
      pfmObj.imageUrl = values[platform + "_imageUrl"];
      pfmObj.dlink = values[platform + "_dlink"];
      pfmObj.image = values[platform + "_image"];
      pfmObj.starActivity = values[platform + "_starActivity"];
      if (pfmObj.point !== undefined && pfmObj.point !== "") {
        platforms.push(pfmObj);
      }
    });

    if (platforms.length === 0) {
      setState((prevState) => ({
        ...prevState,
        visible: true,
        message: "Please Enter at least one platform details",
      }));
      return;
    }

    const payload = {
      ...values,
      platforms,
      activity: spacode,
    };

    if (spacode !== "0") {
      updateActivity(spacode, payload )
        .then((response) => {
          handleApiSuccess(true, response.message);
          navigate("/app/list-activities");
        })
        .catch((error) => {
          // handle error
        });
    } else {
      createActivity(payload)
        .then((response) => {
          handleApiSuccess(true, response.message);
          navigate("/app/list-activities");
        })
        .catch((error) => {
          // handle error
        });
    }
  };

  const loadCategoryTitle = (id) => {
    if (id) {
      getCategoryTitle(id)
        .then((res) => {
          console.log("loadCategoryTitle", loadCategoryTitle);
          setState((prevState) => ({ ...prevState, titles: res.body }));
        })
        .catch((error) => {});
    }
  };

  const renderCategory = () => {
    const categories = [
      {
        name: "others",
        ids: "4869021388202283008",
        id: 4869021388202283008,
        desc: "Others",
      },
    ];
    return (categories || []).map((item, index) => {
      return (
        <Option value={item.ids} key={item.ids}>
          {item.desc}
        </Option>
      );
    });
  };

  const renderChannels = () => {
    const channels = [
      {
        name: "abound",
        desc: "ABOUND",
      },
      {
        name: "TOI",
        desc: "TOI",
      },
    ];
    return (channels || []).map((item, index) => {
      return (
        <Option value={item.name} key={index}>
          {item.desc}
        </Option>
      );
    });
  };

  const renderPlatform = () => {
    return (state.platforms || []).map((item, index) => {
      return (
        <Panel header={`Platform ${item}`} key={item}>
          <Row gutter={[20, 0]} key={index}>
            <Form.Item
              name={`${item}_pfm`}
              initialValue={item}
              label=""
              rules={[{ required: true }]}
            >
              <Input type={"hidden"} />
            </Form.Item>
            <Col span={8}>
              <Form.Item name={`${item}_dlink`} label="Deep Link">
                <Input />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item
                name={`${item}_pts`}
                label={
                  <Tooltip
                    placement="topLeft"
                    title="Enter number of points which user will earn by completing the activity."
                  >
                    Points ?
                  </Tooltip>
                }
              >
                <InputNumber />
              </Form.Item>
            </Col>

            <Col span={4}>
              <Form.Item
                initialValue={false}
                name={`${item}_active`}
                valuePropName="checked"
                label="Active/Inactive"
              >
                <Switch />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item
                name={`${item}_starActivity`}
                valuePropName="checked"
                initialValue={false}
                label="Star Activity"
              >
                <Switch />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item name={`${item}_orderSequence`} label="Sequence Order">
                <InputNumber />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name={`${item}_subTitle`} label="Sub-Title">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name={`${item}_actionText`}
                label="Action Button Title"
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name={`${item}_image`} label="Upload Image">
                <Input type={"file"} id={`${item}_image`} />
              </Form.Item>
            </Col>
            <Form.Item name={`${item}_imageUrl`} label="">
              <Input type={"hidden"} />
            </Form.Item>
          </Row>
        </Panel>
      );
    });
  };

  const handleActivityChange = (id) => {
    //checkActivity?activityId=-7777185503276775464
    let that = this;
    request.get("/checkActivity?activityId=" + id).end(function (err, res) {
      if (res.body.result) {
        that.setState({
          visible: true,
          message: res.body.message,
        });
      }
    });
  };

  const renderTitle = () => {
    return (state.titles || []).map((item, index) => {
      return (
        <Option value={item.activityStr} key={item.activityStr}>
          {item.description}
        </Option>
      );
    });
  };

  const handleOk = () => {
    setState((prevState) => ({
      ...prevState,
      visible: false,
    }));
    if (state.reloadPage) {
      window.location.reload();
    }
  };

  const handleCancel = () => {
    setState((prevState) => ({
      ...prevState,
      visible: false,
    }));
    if (state.reloadPage) {
      window.location.reload();
    }
  };

  let initialValues = {};
  let defaultActiveKey = ["web"];
  if (activityData) {
    const { desc, pfmDetails = [] } = activityData || {};
    // initialValues = JSON.parse(JSON.stringify(props.selectedActivity));
    initialValues = activityData;
    initialValues.activityName = desc;
    initialValues.actval = desc;
    defaultActiveKey = [];
    let pfmdel = pfmDetails;
    initialValues.atype = 0;
    initialValues.category = "4869021388202283008";
    for (let i = 0; i < pfmdel.length; i++) {
      let platform = pfmdel[i].pfm || "web";
      defaultActiveKey.push(platform);
      for (let key in pfmdel[i]) {
        let txt = platform + "_" + key;
        initialValues[txt] = pfmdel[i][key];
      }
    }
    formRef?.current?.setFieldsValue({
      ...initialValues,
    });
  }
  console.log("ini", initialValues);
  const isEditMode = !!activityData;
  return (
    <>
      <Box sx={{ ml: "4", pt: "14 !important", pb: "5", px: 3 }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "25px",
            marginTop: "20px",
            gap: "16px",
          }}
        >
          <Link to={`/app/list-activities`}>
            <ArrowBackIcon
              fontSize="large"
              l
              color="secondary"
              sx={{ background: "#040721", p: 1, borderRadius: "50%" }}
            />
          </Link>
          <Typography
            variant="h5"
            component="h5"
            fontWeight={"bold"}
            color={"#3d3d3d"}
          >
            {spacode !== "0" ? "Edit Activity" : "Add Activity"}
          </Typography>
        </div>
        <Box sx={{ background: "#ffffff", p: 2, mb: 4, pb: 4 }}>
          <div>
            <Form
              style={{ marginTop: "35px" }}
              layout={"vertical"}
              ref={formRef}
              name="control-ref"
              onFinish={submitProduct}
              initialValues={initialValues}
            >
              <Row gutter={[20, 0]}>
                  
                <Col span={8}>
                    <Form.Item
                      name="activityName"
                      rules={[{ required: true }]}
                      label={
                        <Tooltip
                          placement="topLeft"
                          title="Type unique activity name."
                        >
                          Activity Name ?
                        </Tooltip>
                      }
                    >
                      <Input />
                    </Form.Item>
                  </Col>

                <Col span={8}>
                  <Form.Item
                    name="channel"
                    rules={[{ required: true }]}
                    disabled={isEditMode}
                    label={
                      <Tooltip
                        placement="topLeft"
                        title="Choose an activity channel"
                      >
                         Channel ?
                      </Tooltip>
                    }
                  >
                    <Select
                      allowClear
                      showSearch
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      disabled={isEditMode}
                    >
                      {renderChannels()}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={8}>
                  <Form.Item name="clickEvent" label="Click Event">
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Collapse defaultActiveKey={defaultActiveKey}>
                    {renderPlatform()}
                  </Collapse>
                </Col>
                <Divider orientation="left"></Divider>
                <Col span={6}>
                  <Form.Item
                    name="maturityDays"
                    label="Maturity Days"
                    rules={[{ required: true }]}
                  >
                    <InputNumber />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="pexpiry"
                    label="Point expiry days"
                    rules={[{ required: true }]}
                  >
                    <InputNumber />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="atype"
                    label={
                      <Tooltip
                        placement="topLeft"
                        title="Any activity is performed either once in a life time or on regular basis. Choose 'One time' for once in a life time activity or 'Continous' for regular activity."
                      >
                        Frequency ?
                      </Tooltip>
                    }
                    rules={[{ required: true }]}
                  >
                    <Radio.Group disabled={isEditMode}>
                      <Radio value={1}>One Time</Radio>
                      <Radio value={0}>Continuous</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item
                    name="internal"
                    label="Is Internal"
                    rules={[{ required: true }]}
                  >
                    <Radio.Group disabled={isEditMode}>
                      <Radio value={true}>Yes</Radio>
                      <Radio value={false}>No</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>

                <Form.Item
                  noStyle
                  shouldUpdate={(prevValues, currentValues) =>
                    prevValues.atype !== currentValues.atype
                  }
                >
                  {({ getFieldValue }) => {
                    return getFieldValue("atype") == 0 ? (
                      <>
                        <Col span={6}>
                          <Form.Item
                            name="maxcap"
                            label={
                              <Tooltip
                                placement="topLeft"
                                title="a) Limit: Set maximum limit on number of times the user can earn points by performing the activity. b) Duration: Specify time for which 'Limit' will be applicable e.g. If Max Cap Limit is 7 and Duration is 1 day. And any user performs 10 activity in 1 day then only 7 will be eligible for earning points remaining 3 won't."
                              >
                                Max Cap Limit ?
                              </Tooltip>
                            }
                            initialValue={"0"}
                            rules={[{ required: true }]}
                          >
                            <InputNumber />
                          </Form.Item>
                        </Col>
                        <Col span={6}>
                          <Form.Item
                            name="capperiod"
                            label={
                              <Tooltip
                                placement="topLeft"
                                title="a) Limit: Set maximum limit on number of times the user can earn points by performing the activity. b) Duration: Specify time for which 'Limit' will be applicable e.g. If Max Cap Limit is 7 and Duration is 1 day. And any user performs 10 activity in 1 day then only 7 will be eligible for earning points remaining 3 won't."
                              >
                                Max Cap Duration (Days) ?
                              </Tooltip>
                            }
                            initialValue={"0"}
                            rules={[{ required: true }]}
                          >
                            <InputNumber />
                          </Form.Item>
                        </Col>
                        <Col span={6}>
                          <Form.Item
                            name="climit"
                            label={
                              <Tooltip
                                placement="topLeft"
                                title="It is the time gap required between 2 successive instances of the same activity to make it legitimate to get rewarded e.g. if credit limit is 30 seconds for comment posting. And any user posts 2 comments in 15 seconds gap then he won't earn point for 2nd comment."
                              >
                                Cap period (sec) ?
                              </Tooltip>
                            }
                            initialValue={"0"}
                            rules={[{ required: true }]}
                          >
                            <InputNumber />
                          </Form.Item>
                        </Col>
                      </>
                    ) : null;
                  }}
                </Form.Item>
                <Col span={24}>
                  <Collapse accordion defaultActiveKey={["1"]}>
                    <Panel header="Additional Configuration" key="1">
                      <Row gutter={[20, 0]} key={"addiConfig"}>
                        <Col span={4}>
                          <Form.Item
                            name="isClientSide"
                            label="Client Side"
                            initialValue={false}
                            valuePropName="checked"
                          >
                            <Switch />
                          </Form.Item>
                        </Col>
                        <Col span={4}>
                          <Form.Item
                            name="bonusActivity"
                            label="Bonus Activity"
                            initialValue={false}
                            valuePropName="checked"
                          >
                            <Switch disabled={isEditMode} />
                          </Form.Item>
                        </Col>
                        <Col span={4}>
                          <Form.Item
                            name="flexiActivity"
                            label="Flexi Award"
                            initialValue={false}
                            valuePropName="checked"
                          >
                            <Switch />
                          </Form.Item>
                        </Col>
                        <Col span={4}>
                          <Form.Item
                            name="globalValidatorSkip"
                            label="Is Whitelisted?"
                            initialValue={false}
                            valuePropName="checked"
                          >
                            <Switch />
                          </Form.Item>
                        </Col>
                        <Col span={4}>
                          <Form.Item
                            name="timeBound"
                            label={
                              <Tooltip
                                placement="topLeft"
                                title="Reward against any activity can be set for a fixed time period or unlimited time. Choose 'Yes' for fixed time period else 'No' for unlimited time."
                              >
                                Time Bound ?
                              </Tooltip>
                            }
                            initialValue={false}
                          >
                            <Switch />
                          </Form.Item>
                        </Col>
                        <Form.Item
                          noStyle
                          shouldUpdate={(prevValues, currentValues) =>
                            prevValues.timeBound !== currentValues.timeBound
                          }
                        >
                          {({ getFieldValue }) => {
                            return getFieldValue("timeBound") === true ? (
                              <>
                                <Col span={8}>
                                  <Form.Item
                                    name="startDate"
                                    label="Start Date "
                                  >
                                    <DatePicker />
                                  </Form.Item>
                                </Col>
                                <Col span={8}>
                                  <Form.Item name="endDate" label="End Date ">
                                    <DatePicker />
                                  </Form.Item>
                                </Col>
                              </>
                            ) : null;
                          }}
                        </Form.Item>
                      </Row>
                    </Panel>
                  </Collapse>
                </Col>
              
              </Row>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={state.submitting}
                  style={{ marginTop: "25px" }}
                >
                  Submit
                </Button>
              </Form.Item>
            </Form>
            <Modal
              title="Activity"
              visible={state?.visible}
              onOk={handleOk}
              onCancel={handleCancel}
            >
              {state?.message}
            </Modal>
          </div>
        </Box>
      </Box>
    </>
  );
}

export default CreateActivity;
